import { render } from "./MobileSidebar.vue?vue&type=template&id=3039afee&scoped=true"
import script from "./MobileSidebar.vue?vue&type=script&lang=js"
export * from "./MobileSidebar.vue?vue&type=script&lang=js"

import "./MobileSidebar.vue?vue&type=style&index=0&id=3039afee&lang=scss&scoped=true"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3039afee"]])

export default __exports__